import cloneDeep from 'lodash/cloneDeep';

export default {
  INIT_EDITOR(state, { id, relativeVersionId = null, entity }) {
    state.id = id;
    state.relativeVersionId = relativeVersionId;
    state.entity = entity;
    state.errors = [];
  },
  SET_ENTITY_DATA(state, data) {
    const { fieldsConfig, ...editor } = data;
    state.master = editor;
    state.draft = cloneDeep(editor);
    state.fieldsConfig = (fieldsConfig || []).reduce((acc, fieldConfig) => {
      if (fieldConfig.field) {
        acc[fieldConfig.field] = fieldConfig;
      }
      return acc;
    }, {});
    state.relativeVersionId = data.relativeVersionId || null;
    state.versionId = data.versionId || null;
  },
  UPDATE_DRAFT(state, fields) {
    state.draft = { ...state.draft, ...cloneDeep(fields) };
  },
  RESET_DRAFT(state) {
    state.draft = {};
  },
  RESET_MASTER(state) {
    state.master = {};
  },
  SET_FORM_ERRORS(state, errors) {
    state.errors = cloneDeep(errors);
  },
  TOGGLE_ADVANCED_EDITOR(state) {
    state.advancedMode = !state.advancedMode;
  },
  ENABLE_ADVANCED_EDITOR(state) {
    state.advancedMode = true;
  },
};
